module.exports = __webpack_public_path__ + "img/filter.94a1f6ed.svg";